import React, { useState } from 'react';
import { Box, Tooltip, } from '@material-ui/core';
import useStyles from './style';








export function HtmlTooltip({
  toolTipBody,
  children,
  clickable,
  placement,
  ...props
}) {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles();
  // Need to set some Tooltop leaveDelay props for clickable tooltip,
  // so the link inside tooltip content can works properly.
  const leaveDelay = clickable ? 200 : undefined;

  const onClick = () => {
    if (clickable) {
      setIsOpen(!isOpen);
    }
  };

  return (
    React.createElement(Tooltip, {
      classes: {
        tooltip: classes.container,
      },
      placement: placement || 'left',
      interactive: true,
      title: React.createElement(Box, null, toolTipBody),
      disableHoverListener: clickable,
      open: isOpen,
      onOpen: () => setIsOpen(true),
      onClose: () => setIsOpen(false),
      leaveDelay: leaveDelay,
      ...props,}
    
      , React.createElement(Box, { onClick: onClick, style: { width: 'fit-content' },}
        , children
      )
    )
  );
}
